export enum RoutePaths {
  HOME = '/',
  SIGN_IN = '/sign-in',
  SIGN_UP = '/sign-up',
  STYLE_PLAN = '/style-plan',
  GUIDES = '/guides',
  OUTFITS = '/outfits',
  MY_ACCOUNT = '/me',
  PROFILE = '/account',
  STYLE_PLAN_DAY = '/style-plan/:day',
  UNSUBSCRIBE = '/unsubscribe',
  NOT_FOUND = '*',
  SIGN_OUT = '/sign-out',
  SUPPORT = '/support',
  RENEW_SUBSCRIPTION = '/renew-subscription',
  SUBSCRIPTION_INFO = '/subscription',
  ARTICLE = '/article',
  STYLE_ARTICLE = '/style-article',
  HIGHLIGHTS = '/highlights',
  STYLISTS = '/stylists',
  SUPPORT_FEEDBACK = '/support_feedback',
  INSIGHTS = '/insights',
  INSIGHTS_CATEGORY = '/insights/:categoryId',
  INSIGHTS_COLLECTION = '/insights/collection/:collectionId',
  BOOKMARKS = '/bookmarks',
  MY_PLAN = '/my-plan',
}
